import api from "api";
import Modal from "components/Modal";
import ModalLayout from "components/ModalLayout";
import firebase from "config/firebase";
import {handleError} from "helpers/errors";
import {AwaitableModal} from "hooks/useAwaitableModal";
import {useState} from "react";

const EditPassword: AwaitableModal<{}, {}> = ({open, onCancel, resolve}) => {
  const [oldPass, setOldPass] = useState("");
  const [oldPassVisible, setOldPassVisible] = useState(false);
  const [password, setPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const onEdit = () => {
    if (submitting) return;
    if (!oldPass) return handleError("Please enter your old password");
    if (!password) return handleError("Please enter your new password");
    if (!confirmPassword) return handleError("Please confirm your new password");
    if (password !== confirmPassword) return handleError("Passwords do not match");
    setSubmitting(true);
    api
      .updatePassword(oldPass, password)
      .then(async () => {
        await firebase.auth.currentUser?.reload();
        resolve();
      })
      .finally(() => setSubmitting(false));
  };

  return (
    <Modal open={open} close={!submitting ? onCancel : () => {}}>
      <ModalLayout
        title="Change Password"
        footer={
          <>
            <button className="btn-secondary" disabled={submitting} onClick={onCancel}>
              Cancel
            </button>
            <button className="btn-primary" disabled={submitting} onClick={onEdit}>
              Save Changes
            </button>
          </>
        }
      >
        {(
          [
            {
              value: oldPass,
              set: setOldPass,
              visible: oldPassVisible,
              setVisible: setOldPassVisible,
              placeholder: "Old Password",
            },
            {
              value: password,
              set: setPassword,
              visible: passwordVisible,
              setVisible: setPasswordVisible,
              placeholder: "New Password",
            },
            {
              value: confirmPassword,
              set: setConfirmPassword,
              visible: confirmPasswordVisible,
              setVisible: setConfirmPasswordVisible,
              placeholder: "Confirm Password",
            },
          ] as const
        ).map(({value, set, visible, setVisible, placeholder}) => (
          <div key={placeholder} className="relative">
            <input
              type={visible ? "text" : "password"}
              placeholder={placeholder}
              value={value}
              onChange={(e) => set(e.currentTarget.value)}
              className="w-full"
            />
            <span
              className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-brand-muted cursor-pointer select-none"
              onClick={() => setVisible(!visible)}
            >
              {visible ? "Hide" : "Show"}
            </span>
          </div>
        ))}
      </ModalLayout>
    </Modal>
  );
};

export default EditPassword;
